<template>
  <div class="row clearfix g-3">
    <div class="col-xl-12 col-lg-12 col-md-12 mb-3">
      <!-- Flex Container for Button, Year Label, and Select -->
      <div class="d-flex justify-content-between align-items-center">
        <!-- Button -->
        <button
          class="btn d-flex align-items-center"
          @click="downloadLogs"
          style="font-weight: bold; padding: 0.5rem 1rem; border-radius: 25px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);"
        >
          <i class="fas fa-download me-2" style="font-size: 1.2rem;"></i>
          Αρχείο Καταγραφής Κλήσεων
        </button>

        <!-- Year Selector -->
        <div class="d-flex align-items-center">
          <p class="mb-0 me-2">Έτος:</p>
          <select
            id="yearSelect"
            class="form-select form-select-sm"
            v-model="selyear"
            @change="handleYearChange"
            style="width: auto; min-width:140px"
          >
            <option value="0">Όλα τα έτη</option>
            <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-xl-8 col-lg-8 col-md-8  justify-content-center align-items-center" style="margin-left:15%">
      <!-- Top Row with 2 Cards -->
      <div class="row row-cols-1 row-cols-md-2">
        <div class="col-md-6 mb-4">
          <div class="card" >
            <div class="card-body text-center">
              <h5 class="card-title">Δηλωθέντα Μοσχεύματα</h5>
              <p class="card-text" style="color:#3399cc">{{ data.cntrall || 0 }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-4">
          <div class="card ">
            <div class="card-body text-center">
              <h5 class="card-title">Μοσχεύματα προς εφαρμογή</h5>
              <p class="card-text" style="color:#ff3300">{{ data.cntrnotused || 0 }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Second Row with 2 Cards -->
      <div class="row row-cols-1 row-cols-md-2">
        <div class="col-md-6 mb-4">
          <div class="card">
            <div class="card-body text-center">
              <h5 class="card-title">Εφαρμοσμένα Μοσχεύματα</h5>
              <p class="card-text" style="color:#00cc00">{{ data.cntrused || 0 }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-4">
          <div class="card" style="background-color: #ff9900;">
            <div class="card-body text-center">
              <h5 class="card-title" style="color:white">Ληγμένα μοσχεύματα</h5>
              <p class="card-text" style="color:white">{{ data.cntrexpired || 0 }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Single Card Row -->
      <div class="row row-cols-1 mt-5">
        <div class="col-md-6 mb-4" style="margin-left:25%">
          <div class="card" style="background-color: #ff0000;">
            <div class="card-body text-center">
              <h5 class="card-title" style="color:white">Ορφανά Μοσχεύματα</h5>
              <p class="card-text" style="color:white">{{ data.cntrorphans || 0 }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import ApexCharts from "apexcharts";
import { useToast } from "vue-toastification";
import apiClient from "@/services/api";
import { mapGetters } from "vuex";


export default {
  data() {
    const currentYear = new Date().getFullYear();
    return {
      selyear: currentYear.toString(),
      years: Array.from({ length: 5 }, (_, i) => (currentYear - i).toString()),
      data: {},
    };
  },
  computed: {
    ...mapGetters({
      getUserPermission: "getUserPermission",
      getSuperUserPermission: "getSuperUserPermission",
    }),
    superUser() {
      return this.getSuperUserPermission === 1;
    },
  },
  methods: {
    async fetchStatistics() {
      const response = await apiClient.get(
        `/eomws/eomdashcounters2/?selyear=${this.selyear}`
      );
      return response;
    },
    async handleYearChange() {
      try {
        const response = await this.fetchStatistics();
        this.data = response.data.data || {};
      } catch (error) {
        console.error("Error fetching statistics for selected year:", error);
      }
    },

    async downloadLogs() {
      try {
        // Fetch logs from the API
        const response = await apiClient.get("/eomws/getlogs", {
          headers: {
            Accept: "application/xml", // Ensure the server responds with XML
          },
        });

        // Create a Blob from the XML response
        const blob = new Blob([response.data], { type: "application/xml" });

        // Create a download link
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "ΑΡΧΕΙΟ ΚΑΤΑΓΡΑΦΗΣ ΚΛΗΣΕΩΝ.xml"; // Name the downloaded file
        document.body.appendChild(link);
        link.click();

        // Clean up the link after download
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading logs:", error);
      }
    },
  
  },
  
  async mounted() {
    try {
      const response = await this.fetchStatistics();
      this.data = response.data.data || {};
    } catch (error) {
      console.error("Error fetching statistics:", error);
    }
  },
};
</script>

<style scoped>

@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css");

.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.card {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border-radius: 10px;
    background-color: #f2f2f2;
    height: 100px; /* Fixed height for all cards */

    
}
.card-title {
  font-weight: bold;
  font-size: 20px;
    color: #ccc;
}

.card-text {
  font-weight: bold;
  font-size: 20px;
 
}
.form-select-sm {
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
}
</style>
